var scope_0 = require('/codebuild/output/src4284345706/src/gatsby-schroeder/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7535c70a51b9bc8bbbc01939812e75f4.js').default;export default
        Object.assign({}, scope_0 )
    